import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-173" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-4xl" data-id="element-174" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-175" data-mp="2w5yfx5viwj5p">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-176" data-mp="2w4wxuhg3aweh">
            Czy rozpoznajesz siebie w tych sytuacjach?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-177" data-mp="2m93iyreweqtj">
            Jeśli choć jedna z nich brzmi znajomo — Muzyka Gotowa™ powstała
            właśnie dla Ciebie.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-3" data-id="element-178" data-mp="2d8or197fidh2">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-179" data-mp="bg8wefjvk96o">
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-180" data-mp="6ih7luej136p" />
                <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-181" data-mp="3jng8jy9gxi8s">
                  {item.text}
                </span>
              </li>;
        })}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-182" data-mp="39p0gnt2ma4y8">
          Zasługujesz na znacznie więcej →
        </p>
      </div>
    </section>;
}